import _typeof from "/app/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
var FILTER_PROPRIETES = [{
  key: "type",
  label: "Gamme"
}, {
  key: "provider",
  label: "Fournisseur"
}, {
  key: "look",
  label: "Decor"
}];
import { defineComponent, ref, watch } from "vue";
import ModalLayout from "@/components/modals/ModalLayout.vue";
import Info from "../parts/Info.vue";
import { setFloorPattern } from "@/core/helpers/config";
import axios from "axios";
var DEBUG = process.env.VUE_APP_DEBUG == "true";
export default defineComponent({
  props: {
    payload: Object
  },
  components: {
    ModalLayout: ModalLayout,
    Info: Info
  },

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  setup: function setup() {
    var filtersSelected = ref({});
    var filterOptions = ref({});
    var filtredPatterns = ref([]);
    var selectedPattern = ref();
    var loading = ref(false);
    var checkedPatterns = ref({});
    watch(function () {
      return _objectSpread({}, checkedPatterns.value);
    }, function () {
      var _Object$keys;

      console.log({
        selected: (_Object$keys = Object.keys(checkedPatterns.value)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.filter(function (e) {
          return checkedPatterns.value[e];
        })
      });
    }, {
      immediate: false
    });

    var fetchFiltredPatterns = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(filter) {
        var url, searchParams, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                _context.prev = 1;
                url = "".concat(process.env.VUE_APP_API_URL, "process-image/patterns");
                searchParams = new URLSearchParams();
                if (_typeof(filter) == "object") Object.keys(filter).forEach(function (filterKey) {
                  return filter[filterKey] && searchParams.set(filterKey, filter[filterKey]);
                });
                _context.next = 7;
                return axios.get(url + '?' + searchParams.toString());

              case 7:
                response = _context.sent;
                filterOptions.value = response.data.filter;
                filtredPatterns.value = response.data.patterns;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0); //handleError("Erreur de connexion");

              case 15:
                loading.value = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12]]);
      }));

      return function fetchFiltredPatterns(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    watch(function () {
      return _objectSpread({}, filtersSelected.value);
    }, function (filter) {
      fetchFiltredPatterns(filter);
    }, {
      immediate: true
    });

    var handleChangeFloor = function handleChangeFloor(floor) {
      selectedPattern.value = floor;
      setFloorPattern(floor.image);
    };

    var patternImage = function patternImage(filename) {
      return "".concat(process.env.VUE_APP_API_URL, "process-image/display/rawPatterns/").concat(filename);
    };

    return {
      selectedPattern: selectedPattern,
      filtersSelected: filtersSelected,
      FILTER_PROPRIETES: FILTER_PROPRIETES,
      filterOptions: filterOptions,
      filtredPatterns: filtredPatterns,
      patternImage: patternImage,
      handleChangeFloor: handleChangeFloor,
      checkedPatterns: checkedPatterns,
      DEBUG: DEBUG
    };
  }
});